// extracted by mini-css-extract-plugin
export var addToCartButton = "_rv-b";
export var arrowButtonContainer = "_rv-9";
export var arrowButtonIcon = "_rv-a";
export var carouselArrowButton = "_rv-6";
export var carouselElementContainer = "_rv-1";
export var left = "_rv-7";
export var productDisplayCarouselContainer = "_rv-0";
export var productTileContainer = "_rv-2";
export var productTileImage = "_rv-4";
export var productTileImageContainer = "_rv-3";
export var productTileTitle = "_rv-5";
export var right = "_rv-8";
export var sliderOverflow = "_rv-c";